import { Dispatch } from 'redux';
import { ReducerActions } from '../enums/ReducerActions';
import TranslationService from '../services/TranslationService';

const fetchTranslationsFailed = () => ({
    type: ReducerActions.FETCH_TRANSLATIONS_FAILED
})

const fetchTranslationsSucceded = (translations: any) => ({
    type: ReducerActions.FETCH_TRANSLATIONS_SUCCEEDED,
    translations
})

const fetchTranslations = () => ({
    type: ReducerActions.FETCH_TRANSLATIONS_IN_PROGRESS
})

export default (currentLanguage: string) => (dispatch: Dispatch<any>) => {
    return new Promise<void>(async (resolve, reject) => {
        dispatch(fetchTranslations());
        
        try {
            const translations = await TranslationService.getTranslationsFromApi(currentLanguage);
            dispatch(fetchTranslationsSucceded(translations));
            resolve();
        } catch {
            dispatch(fetchTranslationsFailed());
            reject();
        }
    });
}